import { EMPLEADOS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null,
    perfil: null
};

export default function empleadosReducer(state = initialState, action) {
    switch (action.type) {
        case EMPLEADOS.BUSCAR:
            return { ...state, listado: action.payload };

        case EMPLEADOS.AGREGAR:
            return { ...state, listado: [action.payload, ...state.listado] };

        case EMPLEADOS.EDITAR:
            return {
                ...state,
                listado: state.listado.map(proveedor =>
                    proveedor._id === action.payload._id ? action.payload : proveedor
                )
            };

        case EMPLEADOS.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter(proveedor => proveedor._id !== action.payload)
            };

        case EMPLEADOS.DETALLES:
            return { ...state, detalles: action.payload };

        case EMPLEADOS.PERFIL:
            return { ...state, perfil: action.payload };

        case EMPLEADOS.LIMPIAR:
            return { ...state, detalles: null, perfil: null };

        default:
            return state;
    }
}
